import { capitalize } from "../../utils/textFormats";
import CalculateContainer from "./CalculateContainer";

export default function CalculatedAnalysedParams({ perimeterLength, runningTime, successProbability, groupedLineDistance, percentage, handleAnalysedParams }) {
  return (
    <CalculateContainer handleClick={handleAnalysedParams} color="#b4b4b4" title="Info">
      <p className="analysed-title">Analysed parameters:</p>
      <ul className="analysed-parameters-info">
        <li>Perimeter length: {perimeterLength} meters</li>
        <li>Running time required: {runningTime} minutes</li>
        <li>Success probability: {successProbability * 100}%</li>
        {groupedLineDistance &&
          Object.entries(groupedLineDistance).map(([k, v]) => (
            <li key={k}>
              {capitalize(k)} distance: {Math.round(v)} meters / {percentage[k]} %
            </li>
          ))}
      </ul>
    </CalculateContainer>
  );
}
